module.exports = __webpack_public_path__ + "static/media/travela.13f0c849.svg";